import { ThemeUICSSObject, responsive } from '@apia/theme';
/* IMPORT HERE */

const profiles: ThemeUICSSObject = {
  overflow: 'hidden',

  '.confirm__customButtons': {
    display: 'flex',
    justifyContent: responsive({ 0: 'start', 2: 'flex-end' }),
    px: 1,
  },
  '.confirm__buttonBar': {
    flexDirection: responsive({ 0: 'column', 2: 'row' }),
  },
  '.confirm__defaultButtons': {
    justifyContent: 'end',
  },
  '.container': {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    width: '650px',
    height: '500px',
    gap: 3,
    '&.searchContainer': {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      background: 'palette.background.paper',
      position: 'sticky',
      top: 0,
    },
    '& .searchBar': {
      borderColor: 'palette.border.section',
    },

    '.tree__Container': {
      height: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',

      '& span': {
        flexShrink: 0,
      },

      '.funcLabel, .funcLabel__checkbox': {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'flex-end',
        '& span': {
          fontWeight: '400',
        },
      },
      '.tree__expandIcon': { cursor: 'pointer' },

      '.tree__nodeItemLabelRenderer': {
        display: 'flex',
        gap: 3,
        py: 2,
      },
    },
    '.funcLabel__checkbox:focus': {
      outline: 'none',
    },
    'span.tree__nodeItemLabel:focus-within': {
      outline: '3px solid #3191ff',
      outlineOffset: '-3px',
    },
  },
};

export default profiles;
